import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ModalCompAdvance,
  ModalCompAdvanceUpdate,
  PageSwitch,
  TableCompData,
  ButtonComp,
  CardComp,
} from "../../../components";
// import AdminLayout from "../../../Layout/AdminLayout";
import { SettingMemberRegistrationFeeHeader } from "../../../utils/TableHeader";
import ConfirmModal from "../modules/ConfirmModal";
import NewRegistrationFee from "./modules/NewRegistrationFee";
import ImportRegistrationFeesModal from "./modules/ImportRegistrationFeesModal";
import EmptyTable from "../../../components/Common/EmptyTable";
import {
  useGetRegFeesQuery,
  useDeleteRegFeeMutation,
} from "../../../store/admin/settings/regFeeSlice";
import { dateFromString } from "../../../utils";
import { toast } from "react-hot-toast";
import TablePagination from "../../../components/Table/Pagination";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";
export default function SettingMemberRegistrationFee() {
  const [pageName, setPageName] = useState("Member Registration Fee");
  const navigate = useNavigate();
  const location = useLocation();
  const [modalPage, setModalPage] = useState("");
  const [deleteRegFee] = useDeleteRegFeeMutation();
  const [regFeeId, setRegFeeId] = useState();

  const [page, setPage] = useState(1);
  const { data = {}, error, isLoading } = useGetRegFeesQuery(page);
  const { regFees, pagination } = useMemo(() => {
    const { fees = [], pagination = {} } = data;
    const perPage = pagination?.perPage || pagination?.per_page || 20;
    const formattedFees = fees.map((fee, index) => ({
      ...fee,
      serialNumber: index + 1 + (page - 1) * perPage,
      date: dateFromString(fee.created_at),
    }));
    return { regFees: formattedFees, pagination };
  }, [data, page]);

  const removeRegFee = async (regFeeId) => {
    if (!regFeeId) {
      toast.error("Invalid fee ID");
      setModalPage("");
      return;
    }
    setModalPage("");
    setRegFeeId(null);
    const toastId = toast.loading("Deleting");
    const { data, error } = await deleteRegFee(regFeeId);
    if (error) {
      return toast.error(error?.data?.message || "Error deleting fee", { id: toastId });
    }
    if (data?.status === false) {
      return toast.error(data?.message || "Error deleting fee", { id: toastId });
    }
    return toast.success(data?.message || "Fee deleted successfully", {
      id: toastId,
    });
  };

  if (error && error.status === 401) {
    navigate("/login");
    console.log(error);
  }

  const useModal = [
    {
      name: "Delete Modal",
      component: (
        <ConfirmModal
          title={"Confirm"}
          desc={"Are you sure you want to delete this member registration fee?"}
          setModalToggle={() => setModalPage("")}
          confimAction={() => removeRegFee(regFeeId)}
        />
      ),
    },
    {
      name: "Import Registration Fees",
      component: (
        <ImportRegistrationFeesModal
          handleClose={() => setModalPage("")}
        />
      ),
    },
  ];

  const TableDropDown = [
    {
      name: "Edit",
      action: (data) => {
        navigate(`${location?.pathname}/${data?.regFeeId}`);
      },
    },
    {
      name: "Delete",
      action: (data) => {
        const feeId = data?.regFeeId || data?.id;
        if (feeId) {
          setRegFeeId(feeId);
          setModalPage("Delete Modal");
        } else {
          toast.error("Unable to get fee ID");
        }
      },
    },
  ];

  const usePage = [
    {
      name: "Member Registration Fee",
      component: (
        <>
          <TableCompData
            columns={SettingMemberRegistrationFeeHeader(TableDropDown)}
            data={regFees || []}
            marginBottom={"72px"}
            progressPending={isLoading}
            progressComponent={
              <TableSkeletonLoader rows={10} columns={6} />
            }
            message={
              !isLoading && (
                <EmptyTable
                  Message={
                    "There are currently no member registration fee added"
                  }
                  btnText={"Add new fee"}
                  onClick={() => {
                    setPageName("New Registration Fee");
                  }}
                />
              )
            }
            cellPadding="12px"
          />
          {!isLoading && regFees.length > 0 && (
            <TablePagination {...pagination} handlePageChange={setPage} />
          )}
        </>
      ),
    },
    {
      name: "New Registration Fee",
      component: <NewRegistrationFee onNext={() => {}} />,
    },
  ];

  return (
    <section className="px-2 px-lg-4 min-vh-100">
      <CardComp cardBodyClassName={"py-0"} cardClassName={"pt-4"}>
        <h4 className=" text-black1 fw-bold mb-0">{pageName}</h4>
      </CardComp>
      <div className="mb-4 text-end d-flex gap-2 justify-content-end">
        {pageName === "Member Registration Fee" ? (
          <>
            <ButtonComp
              btnText={"Import from Branch"}
              onClick={() => setModalPage("Import Registration Fees")}
              btnClassName="bg-white py-2 px-4 rounded text-primary1 border-2"
              style={{
                borderColor: "var(--color-primary)",
                color: "var(--color-primary)",
              }}
            />
            <ButtonComp
              btnText={"Create New"}
              onClick={() => setPageName("New Registration Fee")}
              btnClassName="bg-primary1 py-2 px-4 rounded text-white border-0"
            />
          </>
        ) : (
          <ButtonComp
            btnText={"All Fees"}
            onClick={() => setPageName("Member Registration Fee")}
            btnClassName="bg-primary1  py-2 px-4 rounded text-white border-0"
          />
        )}
      </div>
      <PageSwitch pageArray={usePage} pageName={pageName} />
      <ModalCompAdvanceUpdate
        arrayComp={useModal}
        pageName={modalPage}
        handleClose={() => setModalPage("")}
        centered={true}
        size={modalPage === "Import Registration Fees" ? "lg" : "md"}
        close={true}
      />
    </section>
  );
}
